
import { defineComponent, ref } from "vue";
import { useLazySection } from "../composables/useLazySection";

export default defineComponent({
  name: "OpsSection",
  props: {
    ops: { type: Object, required: true },
    loaded: { type: Boolean, default: false },
    error: { type: String, default: null },
  },
  emits: ["visible", "retry"],
  setup(props, { emit }) {
    const root = ref<HTMLElement | null>(null);
    useLazySection(root, () => emit("visible"));
    return { root };
  },
});
